import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DemoNg6LibService {

  constructor() { }
}
